"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseContracts = exports.useSortedContracts = void 0;
const util_1 = require("@app/util");
const moment_1 = __importDefault(require("moment"));
const contractIsActive = (contract, date = (0, moment_1.default)()) => {
    return (0, moment_1.default)(date).isBetween((0, moment_1.default)(contract.period?.start), (0, moment_1.default)(contract.period?.end), 'days', '[]');
};
const sortByContractId = (a, b) => {
    const A = Number.parseInt(a.contractId ?? '', 10);
    const B = Number.parseInt(b.contractId ?? '', 10);
    const hasA = Number.isFinite(A);
    const hasB = Number.isFinite(B);
    if (hasA && !hasB)
        return -1;
    if (!hasA && hasB)
        return 1;
    if (!hasA && !hasB)
        return 0;
    if (A === B)
        return 0;
    return A > B ? 1 : -1;
};
const sortByPeriodEnd = (a, b) => {
    const A = (0, moment_1.default)(a.period?.end);
    const B = (0, moment_1.default)(b.period?.end);
    if (!A.isValid() && B.isValid())
        return -1;
    if (A.isValid() && !B.isValid())
        return 1;
    if (!A.isValid() && !B.isValid())
        return 0;
    if (A.isBefore(B))
        return 1;
    if (A.isAfter(B))
        return -1;
    return 0;
};
const groupByContractId = (input) => {
    const grouped = input.reduce((acc, curr) => {
        if ((0, util_1.isValue)(curr.contractId)) {
            acc.with.push(curr);
        }
        else {
            acc.without.push(curr);
        }
        return acc;
    }, { with: [], without: [] });
    return grouped;
};
const sortContractIdGroups = (input) => {
    input.with.sort(sortByContractId);
    input.without.sort(sortByPeriodEnd);
    return input.with.concat(input.without);
};
const sortContracts = (input) => {
    const groupedByFixed = input.reduce((acc, cur) => {
        const isFixed = cur.compiled?.rules.fixedWorkHours === true;
        if (isFixed) {
            acc.true.push(cur);
        }
        else {
            acc.false.push(cur);
        }
        return acc;
    }, { true: [], false: [] });
    const fixed = sortContractIdGroups(groupByContractId(groupedByFixed.true));
    const notFixed = sortContractIdGroups(groupByContractId(groupedByFixed.false));
    return [...fixed, ...notFixed];
};
const useSortedContracts = (contracts) => {
    return (0, exports.parseContracts)(contracts);
};
exports.useSortedContracts = useSortedContracts;
const parseContracts = (contracts, date = (0, moment_1.default)()) => {
    const contractsWithStart = contracts?.filter((contract) => (0, util_1.isValue)(contract.period?.start)) ?? [];
    const contractsWithNoStart = contracts?.filter((contract) => !(0, util_1.isValue)(contract.period?.start)) ?? [];
    const activeContractsWithNoStart = contractsWithNoStart?.filter((contract) => !(0, util_1.isValue)(contract.period?.end) ||
        (0, moment_1.default)(date).isSameOrBefore((0, moment_1.default)(contract.period?.end))) ?? [];
    const inactiveContractsWithNoStart = contractsWithNoStart?.filter((contract) => (0, util_1.isValue)(contract.period?.end) &&
        (0, moment_1.default)(date).isAfter((0, moment_1.default)(contract.period?.end))) ?? [];
    const firstContract = contractsWithStart?.reduce((acc, contract) => {
        if ((0, util_1.isUndefined)(acc))
            return contract;
        if ((0, moment_1.default)(contract.period?.start).isSameOrBefore(acc?.period?.start))
            return contract;
        return acc;
    }, contractsWithStart?.[0]);
    const lastContract = contracts?.reduce((acc, contract) => {
        if ((0, util_1.isUndefined)(acc))
            return contract;
        const accHasEnd = (0, util_1.isValue)(acc.period?.end);
        const contractHasEnd = (0, util_1.isValue)(contract.period?.end);
        if (!accHasEnd && !contractHasEnd)
            return acc;
        if (!accHasEnd)
            return acc;
        if (!contractHasEnd)
            return contract;
        if ((0, moment_1.default)(contract.period?.end).isAfter((0, moment_1.default)(acc.period?.end))) {
            return contract;
        }
        return acc;
    }, undefined);
    const contractsWithNoEnd = contractsWithStart.filter((contract) => !(0, util_1.isValue)(contract.period?.end));
    const contractsWithEnd = contractsWithStart.filter((contract) => (0, util_1.isValue)(contract.period?.end));
    const activeContracts = sortContracts(contractsWithNoEnd
        .filter((contract) => (0, moment_1.default)(date).isSameOrAfter(contract.period?.start))
        ?.concat(contractsWithEnd?.filter((cont) => contractIsActive(cont, date)))
        .concat(activeContractsWithNoStart));
    const inactiveContracts = sortContracts(contractsWithEnd
        ?.filter((contract) => (0, moment_1.default)(date).isAfter((0, moment_1.default)(contract.period?.end)))
        .concat(inactiveContractsWithNoStart));
    const futureContracts = sortContracts(contractsWithStart?.filter((contract) => (0, moment_1.default)(date).isBefore((0, moment_1.default)(contract.period?.start))) ?? []);
    return {
        activeContracts,
        inactiveContracts,
        futureContracts,
        firstContract,
        lastContract,
    };
};
exports.parseContracts = parseContracts;
